<ux-product-visual
	[product]="product"
	[isDisplayedDuringOrder]="true">
</ux-product-visual>
<div class="questionnaire">
	<h3 class="font-barlow">{{'Laboratory instructions' | translate}}</h3>
	<form [formGroup]="questionnaireForm">
		<!-- Vertical dimension -->
		<section>
			<div class="required-header" [ngClass]="{invalid: verticalDimension.invalid}">
				<h3>{{ getHeadline(MichiganSplintQuestionnaireSection.VERTICAL_DIMENSION) | translate}}</h3>
				@if (verticalDimension.invalid) {
					<p>({{"required" | translate}})</p>
				}
			</div>
			<div formGroupName="verticalDimension">
				<mat-radio-group formControlName="option">
					<mat-radio-button value="{{VerticalDimensionAnswerOption.NO_ADJUSTMENT}}">
						{{ 'No' | translate}}
					</mat-radio-button>
					<mat-radio-button value="{{VerticalDimensionAnswerOption.IF_NECESSARY}}">
						{{ 'ifNecessaryVerticalDimension' | translate }}
					</mat-radio-button>
					<div>
						<mat-radio-button value="{{VerticalDimensionAnswerOption.ADJUST_BY_MM}}">
							{{ 'adjustByMM' |	translate }}
						</mat-radio-button>
						<mat-form-field>
							<input matInput formControlName="text">
							<mat-error>{{ "please fill in" | translate }}</mat-error>
							<mat-hint>({{ "negative values allowed" | translate }})</mat-hint>
						</mat-form-field> mm
					</div>
				</mat-radio-group>
			</div>
		</section>
		<!-- individual comments  -->
		<section>
			<h3>{{ getHeadline(MichiganSplintQuestionnaireSection.INDIVIDUAL_COMMENTS) | translate}}</h3>
			<textarea id="individualComments" formControlName="individualComments"
				placeholder="{{'Anamnesis.ObjectivesCommentPlaceholder' | translate}}"></textarea>
		</section>
	</form>
	<br>
	@if(!checkValid()){
		<mat-error data-cy="required-input-missing-hint">
			{{ "Anamnesis.RequiredInputMissingHint" | translate }}
		</mat-error>
	}
	<br>
	<ux-next-back-actions [disabledNext]="!checkValid()" (action)="onAction($event)"></ux-next-back-actions>
</div>
